import { Controller } from "@hotwired/stimulus"
import debounce from "lodash.debounce"

export default class extends Controller {
  static get targets() { return [ "submit", "clear" ] }

  initialize() {
    this.submit = debounce(this.submit.bind(this), 100)
  }

  connect() {
    this.submitTarget.hidden = true
    this.clearTarget.style.right = "6px"
  }

  submit() {
    this.submitTarget.click()
  }

  hideValidationMessage(event) {
    event.stopPropagation()
    event.preventDefault()
  }
}
